// src/data/products.js
import slide1 from '../assets/img/bg.jpg';
import Banner1 from '../assets/img/banner_img.png';
import Icon1 from '../assets/img/icon1.png';
import Studio from '../assets/img/uniform.jpg';

import Inter1 from '../assets/img/pro_inter_1.svg';
import Inter2 from '../assets/img/pro_inter_2.svg';
import Inter3 from '../assets/img/pro_inter_3.svg';
import Inter4 from '../assets/img/pro_inter_4.svg';
import Inter5 from '../assets/img/pro_inter_5.svg';
import Inter6 from '../assets/img/pro_inter_6.svg';
import Inter7 from '../assets/img/pro_inter_7.svg';
import Icon2 from '../assets/img/Shape.svg';
import Con1 from '../assets/img/confort_1.svg';
import Con2 from '../assets/img/confort_2.svg';
import Con3 from '../assets/img/confort_3.svg';
import Con4 from '../assets/img/confort_4.svg';
import Con5 from '../assets/img/confort_5.svg';
import Con6 from '../assets/img/confort_two.svg';
import Con7 from '../assets/img/confort_7.svg';

import Ser1 from '../assets/img/service_1.jpg';
import Ser2 from '../assets/img/service_2.jpg';
import Ser3 from '../assets/img/service_3.jpg';

import Brand1 from '../assets/img/brand_bg.svg';
import Logo1 from '../assets/img/khazana.svg';
import Logo2 from '../assets/img/mercedes.svg';
import Logo3 from '../assets/img/jktyre.svg';
import Logo4 from '../assets/img/esro.svg';
import Logo5 from '../assets/img/emerald.svg';
import Logo6 from '../assets/img/noku.jpg';
import Logo7 from '../assets/img/muru.svg';
import Logo8 from '../assets/img/hindusthan.svg';
import Logo9 from '../assets/img/lily_beach.svg';
import Logo10 from '../assets/img/volvo.svg';
import Logo11 from '../assets/img/coco.svg';
import Logo12 from '../assets/img/parrys.svg';
import Logo13 from '../assets/img/mrf.svg';
import Logo14 from '../assets/img/ashok.svg';
import Logo15 from '../assets/img/eicher.svg';
import Logo16 from '../assets/img/sundram.svg';
import Logo17 from '../assets/img/hwashin.svg';
import Logo18 from '../assets/img/tvs.svg';
import Logo19 from '../assets/img/the_ritz.svg';
import Logo20 from '../assets/img/kureghivaru.svg';
import Logo21 from '../assets/img/island.svg';

import Get1 from '../assets/img/get_in_touch_bg.jpg';
import Get2 from '../assets/img/get-in-tuch.png';

import Pro1 from '../assets/img/process_img_1.svg';
import Pro2 from '../assets/img/arrow_right.svg';
import Pro3 from '../assets/img/process_img_2.svg';
import Pro4 from '../assets/img/arrow_right.svg';
import Pro5 from '../assets/img/process_img_3.svg';
import Pro6 from '../assets/img/arrow_right.svg';
import Pro7 from '../assets/img/process_img_4.svg';
import Pro8 from '../assets/img/arrow_down.svg';
import Pro9 from '../assets/img/process_img_5.svg';
import Pro10 from '../assets/img/back_arrow.svg';
import Pro11 from '../assets/img/process_img_6.svg';
import Pro12 from '../assets/img/back_arrow.svg';
import Pro13 from '../assets/img/process_img_7.svg';

import User1 from '../assets/img/user_1.jpg';
import User2 from '../assets/img/user_2.jpg';
import User3 from '../assets/img/user_3.jpg';




import manufact from '../assets/img/manufact.png';
import imgta from '../assets/img/imgta.jpg';

import manpro1 from '../assets/img/product/man-pro1.jpg';
import manpro2 from '../assets/img/product/man-pro2.jpg';
import manpro3 from '../assets/img/product/man-pro3.jpg';
import manpro4 from '../assets/img/product/man-pro4.jpg';
import manpro5 from '../assets/img/product/man-pro5.jpg';
import manpro6 from '../assets/img/product/man-pro6.jpg';
import manpro7 from '../assets/img/product/man-pro7.jpg';
import manpro8 from '../assets/img/product/man-pro8.jpg';

import monser1 from '../assets/img/product/ser1.jpg';
import monser2 from '../assets/img/product/ser2.jpg';
import monser3 from '../assets/img/product/ser3.jpg';


import govbg from '../assets/img/product/govimg.png';
import govabout from '../assets/img/product/govabout.png';



import govpro1 from '../assets/img/product/gov-pro1.jpg';
import govpro2 from '../assets/img/product/gov-pro2.jpg';
import govpro3 from '../assets/img/product/gov-pro3.jpg';
import govpro4 from '../assets/img/product/gov-pro4.jpg';
import govpro5 from '../assets/img/product/gov-pro5.jpg';
import govpro6 from '../assets/img/product/gov-pro6.jpg';

import govser1 from '../assets/img/product/ser4.jpg';
import govser2 from '../assets/img/product/ser5.jpg';

import aviimg from '../assets/img/product/aviimg.png';
import aviabout from '../assets/img/product/aviabout.jpg';

import avipro1 from '../assets/img/product/avi-pro1.jpg';
import avipro2 from '../assets/img/product/avi-pro2.jpg';
import avipro3 from '../assets/img/product/avi-pro3.jpg';
import avipro4 from '../assets/img/product/avi-pro4.jpg';
import avipro5 from '../assets/img/product/avi-pro5.jpg';
import avipro6 from '../assets/img/product/avi-pro6.jpg';

import aviSer6 from '../assets/img/product/ser6.jpg';
import aviSer7 from '../assets/img/product/ser7.jpg';


import healthcareimg from '../assets/img/product/healthcare.png';
import healthcareabout from '../assets/img/product/healthcareabout.jpg';

import healthcarepro1 from '../assets/img/product/healthcare-pro1.jpg';
import healthcarepro2 from '../assets/img/product/healthcare-pro2.jpg';
import healthcarepro3 from '../assets/img/product/healthcare-pro3.jpg';
import healthcarepro4 from '../assets/img/product/healthcare-pro4.jpg';
import healthcarepro5 from '../assets/img/product/healthcare-pro5.jpg';
import healthcarepro6 from '../assets/img/product/healthcare-pro6.jpg';

import retailimg from '../assets/img/product/retail.png';
import retailabout from '../assets/img/product/retailabout.jpg';

import retailpro1 from '../assets/img/product/retail-pro1.jpg';
import retailpro2 from '../assets/img/product/retail-pro2.jpg';
import retailpro3 from '../assets/img/product/retail-pro3.jpg';
import retailpro4 from '../assets/img/product/retail-pro4.jpg';
import retailpro5 from '../assets/img/product/retail-pro5.jpg';
import retailpro6 from '../assets/img/product/retail-pro6.jpg';

import retailSer6 from '../assets/img/product/ser8.jpg';
import retailSer7 from '../assets/img/product/ser9.jpg';

import educationalpro1 from '../assets/img/product/educational-pro1.jpg';
import educationalpro2 from '../assets/img/product/educational-pro2.jpg';
import educationalpro3 from '../assets/img/product/educational-pro3.jpg';
import educationalpro4 from '../assets/img/product/educational-pro4.jpg';
import educationalpro5 from '../assets/img/product/educational-pro5.jpg';
import educationalpro6 from '../assets/img/product/educational-pro6.jpg';
import educationalpro7 from '../assets/img/product/educational-pro7.jpg';

import educationalimg from '../assets/img/product/educational.png';
import educationalabout from '../assets/img/product/educationalabout.jpg';


export const products = [
  {
    title: "Industrial & Manufacturing",
    slug: "industrial",
    meta: {
      title: "Industrial Manufacturing Workwear – Durable Safety Uniforms",
      description: "Shop industrial and manufacturing uniforms designed for safety, durability, and comfort. Custom workwear solutions for tough environments.",
      keywords: "industrial manufacturing workwear"
    },
    content: {
      banner: {
        heading: "Industrial & Manufacturing",
        text: "Purpose-built uniforms balancing durability, safety, and everyday wearability",
        img: manufact,
        bg: slide1,
        Iconbtn: Icon1,
      },
      ambience: {
        heading: "Workwear Tailored for Tough Environments",
        text: "In industrial and manufacturing settings, uniforms are more than clothing—they’re a vital layer of safety, performance, and identity. Our workwear is built to withstand demanding conditions while ensuring comfort for long hours on the job. From high-visibility gear to specialized protective apparel, each piece is designed to keep your team safe, confident, and ready for any task. We collaborate closely with you to create role-specific uniforms that meet industry standards while reflecting your company’s professionalism.",
        img: imgta
      },
      industries: {
        heading: "Workwear for Every Role",
        text: "From machine operators to engineers—uniforms designed to perform",
        title1: "Production Floor Operators", img1: manpro2,
        title2: "Welders / Hot Work Crew", img2: manpro3,
        title3: "Maintenance & Utilities", img3: manpro4,
        title4: "Quality / Lab Technicians", img4: manpro5,
        title5: "Warehouse & Logistics", img5: manpro8,
        title6: "Supervisors & Field Engineers", img6: manpro7,
        title7: "Executive & Client-Facing", img7: manpro6,
        title8: "Outdoor / Cold Zone Staff", img8: manpro1,
      },
      process: {
        heading: "Our Process From Concept to Comfort",
        text: "A collaborative, insight-driven process to transform spaces with textiles that embody your brand’s<br> story and elevate guest experience.",
        title1: "1. RESEARCH", img1: Con1,
        title2: "2. INSPIRATION", img2: Con6,
        title3: "3. MAPPING", img3: Con2,
        title4: "4. MOOD BOARDING", img4: Con3,
        title5: "5. MOTIFS", img5: Con7,
        title6: "6. DESIGN SHEETS", img6: Con4,
        title7: "7. SAMPLING", img7: Con5,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },

      getintuch: {
         heading: "Get In Touch",
         text: "Every great idea begins with a chat. Let’s talk about your next project.",
         img1: Get2,
         img2: Get1,
         img3: Icon2,
      },
     brands:{
        img: Brand1,
      },
      services: [
        { title: "Uniform packaging", text: "per staff member", img: monser1 },
        { title: "Logo embroidery", text: "color matching", img: monser2 },
        { title: "Accessories", text: "like belts, ties, badges", img: monser3 }
      ],
      clients: [
        Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8,
        Logo9, Logo10, Logo11, Logo12, Logo13, Logo14, Logo15,
        Logo16, Logo17, Logo18, Logo19, Logo20, Logo21
      ],
      processsketch: {
        heading: "OUR PROCESS: FROM SKETCH TO STITCH",
        text: "From understanding your brand to delivering the finished product, we perfect every step.",
        title1: "1. BRAND REQUIREMENT", img1: Pro1,
        title2: "2. PRODUCT DESIGN", img2: Pro3,
        title3: "3. SAMPLING AND PRODUCT DEV", img3: Pro5,
        title4: "4. FORECASTING", img4: Pro7,
        title5: "7. DELIVERY", img5: Pro13,
        title6: "6. WAREHOUSING AND SHIPPING", img6: Pro11,
        title7: "5. MANUFACTURING", img7: Pro9,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
     testimonials: [
        {
          name: "Ananya Mehta",
          position: "Senior Merchandising Manager",
          img: User1,
          text: `What I value about Saraogi Clothing is that they understand fast-changing retail trends and still deliver on time.`,
        },
        {
          name: "Rajiv Nair",
          position: "Employee Welfare & Operations",
          img: User2,
          text: `Our factory staff uniforms from Saraogi have lasted far longer than expected, and the comfort feedback from workers has been very positive.`,
        },
        {
          name: "Natasha Singh",
          position: "Director – Guest Experience",
          img: User3,
          text: `The housekeeping and front desk uniforms they designed for us are both elegant and practical, our team loves wearing them.`,
        },
        {
          name: "Emma Collins",
          position: "Senior Buyer – Womenswear",
          img: User3,
          text: `We've worked with many suppliers, but Saraogi Clothing stands out for their reliability and attention to fabric detail.`,
        },
        {
          name: "Lukas Weber",
          position: "Procurement Manager",
          img: User3,
          text: `Their workwear solutions are practical and long-lasting, our technicians noticed the difference almost immediately.`,
        },
        {
          name: "Aisha Al Mansoori",
          position: "Head of Operations",
          img: User3,
          text: `Saraogi delivered exactly what we needed—uniforms that reflect luxury while staying comfortable through long shifts.`,
        },
      ],
       faq: [
        {
          question: "1. What types of industrial uniforms does Workdayz offer?",
          answer: " Workdayz provides durable and functional industrial uniforms designed for various sectors including manufacturing, construction, and heavy-duty work environments. Their uniforms prioritize safety, comfort, and long-lasting performance during demanding tasks."
        },
        {
          question: "2. Are Workdayz industrial uniforms customizable?",
          answer: " Yes, uniforms can be customized with your company’s logo, colors, and design preferences to align with your brand identity. Customization options ensure both functionality and professional appearance for your workforce."
        },
        {
          question: "3. What materials are used in Workdayz industrial uniforms?",
          answer: "  Workdayz uses high-quality, rugged fabrics that withstand tough working conditions and frequent washing. Materials are chosen for durability, comfort, and resistance to wear in industrial settings."
        },
        {
          question: "4. Do Workdayz industrial uniforms include safety features?",
          answer: " Many uniforms are equipped with practical safety elements like reflective strips, reinforced stitching, and utility pockets. These features help enhance visibility and convenience for workers on the job."
        },
        {
          question: "5. How does Workdayz ensure quality in industrial uniforms?",
          answer: " Workdayz follows strict quality controls during production to ensure every uniform meets performance and durability standards. Each garment is inspected to support consistent comfort and long-term use."
        },
        {
          question: "6. How can I order industrial uniforms from Workdayz?",
          answer: "  You can place orders through the Workdayz website or contact their sales team directly for assistance. Their team will guide you through product selection, customization, and delivery options."
        },
      ],
      getInTouch: { bg: Get1, img: Get2 }
     
    } 
  },
  {
    title: "Retail and Brand Spaces",
    slug: "retail-brand-spaces",
    meta: {
      title: "Premium Retail Uniform Solutions for Brand Spaces and staff",
      description: "Uniforms for retail & brand spaces—crafted to reflect your identity, boost customer connection, and ensure staff look professional from floor to storefront.",
      keywords: "retail uniforms"
    },
    content: {
      banner: {
        heading: "Retail and Brand Spaces",
        text: "Polished uniforms designed to strengthen brand presence and connect with customers",
        img: retailimg,
        bg: slide1,
        Iconbtn: Icon1,
      },
      ambience: {
        heading: "Great Workwear for Lasting Brand Impact",
        text: "In retail, your team is the face of your brand. Our uniforms are designed to balance style, comfort, and brand alignment, ensuring your staff not only look sharp but also feel confident on the floor. From luxury brand stores to bustling retail outlets, we create apparel that enhances customer interactions and reinforces your brand identity at every touchpoint.",
        img: retailabout
      },
      industries: {
        heading: "Uniforms for Every Team Member",
        text: "From sales associates to store managers—uniforms designed for presence and performance",
        title1: "Retail Floor Staff", img1: retailpro1,
        title2: "POOL SIDE", img2: retailpro2,
        title3: "Corporate Executives", img3: retailpro3,
        title4: "Guest Relations / FO", img4: retailpro4,
        title5: "Event Crew", img5: retailpro5,
        title6: "Managers", img6: retailpro6,
      },
      process: {
        heading: "Our Process From Concept to Comfort",
        text: "A collaborative, insight-driven process to transform spaces with textiles that embody your brand’s<br> story and elevate guest experience.",
        title1: "1. RESEARCH", img1: Con1,
        title2: "2. INSPIRATION", img2: Con6,
        title3: "3. MAPPING", img3: Con2,
        title4: "4. MOOD BOARDING", img4: Con3,
        title5: "5. MOTIFS", img5: Con7,
        title6: "6. DESIGN SHEETS", img6: Con4,
        title7: "7. SAMPLING", img7: Con5,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },


      getintuch: {
         heading: "Get In Touch",
         text: "Every great idea begins with a chat. Let’s talk about your next project.",
         img1: Get2,
         img2: Get1,
         img3: Icon2,
      },
     brands:{
        img: Brand1,
      },
      services: [
        { title: "Uniform packaging", text: "per staff member", img: retailSer7 },
        { title: "Logo embroidery", text: "color matching", img: retailSer6 },
      ],
      clients: [
        Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8,
        Logo9, Logo10, Logo11, Logo12, Logo13, Logo14, Logo15,
        Logo16, Logo17, Logo18, Logo19, Logo20, Logo21
      ],
      processsketch: {
        heading: "OUR PROCESS: FROM SKETCH TO STITCH",
        text: "From understanding your brand to delivering the finished product, we perfect every step.",
        title1: "1. BRAND REQUIREMENT", img1: Pro1,
        title2: "2. PRODUCT DESIGN", img2: Pro3,
        title3: "3. SAMPLING AND PRODUCT DEV", img3: Pro5,
        title4: "4. FORECASTING", img4: Pro7,
        title5: "7. DELIVERY", img5: Pro13,
        title6: "6. WAREHOUSING AND SHIPPING", img6: Pro11,
        title7: "5. MANUFACTURING", img7: Pro9,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
     testimonials: [
        {
          name: "Ananya Mehta",
          position: "Senior Merchandising Manager",
          img: User1,
          text: `What I value about Saraogi Clothing is that they understand fast-changing retail trends and still deliver on time.`,
        },
        {
          name: "Rajiv Nair",
          position: "Employee Welfare & Operations",
          img: User2,
          text: `Our factory staff uniforms from Saraogi have lasted far longer than expected, and the comfort feedback from workers has been very positive.`,
        },
        {
          name: "Natasha Singh",
          position: "Director – Guest Experience",
          img: User3,
          text: `The housekeeping and front desk uniforms they designed for us are both elegant and practical, our team loves wearing them.`,
        },
        {
          name: "Emma Collins",
          position: "Senior Buyer – Womenswear",
          img: User3,
          text: `We've worked with many suppliers, but Saraogi Clothing stands out for their reliability and attention to fabric detail.`,
        },
        {
          name: "Lukas Weber",
          position: "Procurement Manager",
          img: User3,
          text: `Their workwear solutions are practical and long-lasting, our technicians noticed the difference almost immediately.`,
        },
        {
          name: "Aisha Al Mansoori",
          position: "Head of Operations",
          img: User3,
          text: `Saraogi delivered exactly what we needed—uniforms that reflect luxury while staying comfortable through long shifts.`,
        },
      ],
       faq: [
  {
    question: "1. What retail uniform solutions does Workdayz offer?",
    answer: " Workdayz provides tailored retail uniforms designed to match your brand’s identity and customer experience goals. Their uniforms blend durability with professional style for shop floor teams and store associates."
  },
  {
    question: "2. Can Workdayz customize uniforms for retail staff?",
    answer: " Yes, Workdayz creates customized designs based on your brand colors, logo, and operational needs. They collaborate with clients to ensure uniforms reflect brand personality and comfort requirements."
  },
  {
    question: "3. Are there material options suitable for daily retail use?",
    answer: "  Workdayz uses quality fabrics that balance comfort, durability, and ease of maintenance for everyday wear. These materials are selected to withstand long shifts and frequent washing without losing shape."
  },
  {
    question: "4. Do Workdayz retail uniforms support seasonal collections?",
    answer: " Yes, tailored seasonal uniform options are available to accommodate changing weather and store themes. You can work with the design team to update collections for comfort and brand continuity."
  },
  {
    question: "5. How does Workdayz ensure quality in retail uniform production?",
    answer: " Uniforms are crafted with careful stitching, quality control checks, and materials suitable for retail environments. Each product is reviewed to ensure standards of appearance and performance are consistently met."
  },
  {
    question: "6. How can I order retail brand spaces uniforms from Workdayz?",
    answer: " You can request a quote or consultation through the contact form on the Workdayz website. Alternatively, contact their sales team directly to discuss your retail uniform requirements."
  },
],
      getInTouch: { bg: Get1, img: Get2 }
    }
  },
  {
    title: "Aviation",
    slug: "corporate-admin",
    meta: {
      title: "Corporate Uniforms for Aviation | Workdayz",
      description: "Explore premium corporate uniforms for aviation professionals. Workdayz designs stylish, comfortable, and durable attire for airlines and ground staff.",
      keywords: "Corporate Uniforms for Aviation"
    },
    content: {
      banner: {
        heading: "Aviation",
        text: "Workwear designed for polished appearances, brand ethos and all-day comfort at work",
        img: aviimg,
        bg: slide1,
        Iconbtn: Icon1,
      },
      ambience: {
        heading: "Corporate Attire that Commands Respect",
        text: "In the corporate world, every detail speaks for your brand. Our uniforms for administrative and corporate teams are designed to project confidence, professionalism, and respect, while offering all-day comfort. From client-facing executives to support staff, we create cohesive workwear collections that strengthen your organization’s identity and leave a lasting impression.",
        img: aviabout
      },
      industries: {
        heading: "Uniforms for Every Professional Role",
        text: "From receptionists to administrative staff—uniforms designed for confidence and comfort",
        title1: "CABIN cREW", img1: avipro1,
        title2: "Lounge & Hospitality", img2: avipro2,
        title3: "PILOTS", img3: avipro3,
        title4: "GROUND STAFF", img4: avipro4,
        title5: "F&B & In-flight Services", img5: avipro5,
        title6: "Airport Security", img6: avipro6,
      },
      process: {
        heading: "Our Process From Concept to Comfort",
        text: "A collaborative, insight-driven process to transform spaces with textiles that embody your brand’s<br> story and elevate guest experience.",
        title1: "1. RESEARCH", img1: Con1,
        title2: "2. INSPIRATION", img2: Con6,
        title3: "3. MAPPING", img3: Con2,
        title4: "4. MOOD BOARDING", img4: Con3,
        title5: "5. MOTIFS", img5: Con7,
        title6: "6. DESIGN SHEETS", img6: Con4,
        title7: "7. SAMPLING", img7: Con5,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
      getintuch: {
         heading: "Get In Touch",
         text: "Every great idea begins with a chat. Let’s talk about your next project.",
         img1: Get2,
         img2: Get1,
         img3: Icon2,
      },
     brands:{
        img: Brand1,
      },
      services: [
        { title: "Uniform packaging", text: "per staff member", img: aviSer7 },
        { title: "Logo embroidery", text: "color matching", img: aviSer6 },
      ],
      clients: [
        Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8,
        Logo9, Logo10, Logo11, Logo12, Logo13, Logo14, Logo15,
        Logo16, Logo17, Logo18, Logo19, Logo20, Logo21
      ],
      processsketch: {
        heading: "OUR PROCESS: FROM SKETCH TO STITCH",
        text: "From understanding your brand to delivering the finished product, we perfect every step.",
        title1: "1. BRAND REQUIREMENT", img1: Pro1,
        title2: "2. PRODUCT DESIGN", img2: Pro3,
        title3: "3. SAMPLING AND PRODUCT DEV", img3: Pro5,
        title4: "4. FORECASTING", img4: Pro7,
        title5: "7. DELIVERY", img5: Pro13,
        title6: "6. WAREHOUSING AND SHIPPING", img6: Pro11,
        title7: "5. MANUFACTURING", img7: Pro9,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
    testimonials: [
        {
          name: "Ananya Mehta",
          position: "Senior Merchandising Manager",
          img: User1,
          text: `What I value about Saraogi Clothing is that they understand fast-changing retail trends and still deliver on time.`,
        },
        {
          name: "Rajiv Nair",
          position: "Employee Welfare & Operations",
          img: User2,
          text: `Our factory staff uniforms from Saraogi have lasted far longer than expected, and the comfort feedback from workers has been very positive.`,
        },
        {
          name: "Natasha Singh",
          position: "Director – Guest Experience",
          img: User3,
          text: `The housekeeping and front desk uniforms they designed for us are both elegant and practical, our team loves wearing them.`,
        },
        {
          name: "Emma Collins",
          position: "Senior Buyer – Womenswear",
          img: User3,
          text: `We've worked with many suppliers, but Saraogi Clothing stands out for their reliability and attention to fabric detail.`,
        },
        {
          name: "Lukas Weber",
          position: "Procurement Manager",
          img: User3,
          text: `Their workwear solutions are practical and long-lasting, our technicians noticed the difference almost immediately.`,
        },
        {
          name: "Aisha Al Mansoori",
          position: "Head of Operations",
          img: User3,
          text: `Saraogi delivered exactly what we needed—uniforms that reflect luxury while staying comfortable through long shifts.`,
        },
      ],
          faq: [
  {
    question: "1. What types of corporate uniforms does Workdayz offer?",
    answer: "Workdayz provides tailored corporate uniforms including shirts, trousers, skirts, blazers, and coordinated sets for office environments. Each uniform is designed to reflect professionalism while ensuring comfort during long work hours"
  },
  {
    question: "2. Can Workdayz customize corporate uniforms for my brand?",
    answer: " Yes, Workdayz offers customization with your brand colors, logos, and specific design preferences. Custom options help maintain brand identity and enhance team unity."
  },
  {
    question: "3. Are the corporate uniforms suitable for all work environments?",
    answer: " Workdayz corporate uniforms are crafted with quality fabrics suitable for formal office settings and business events. The materials are chosen for durability, comfort, and a polished appearance."
  },
  {
    question: "4. What fabric options are available for corporate uniforms?",
    answer: " Various fabric blends are available, offering breathability, wrinkle resistance, and ease of maintenance. Clients can select fabrics based on comfort preferences and workplace demands."
  },
  {
    question: "5. How does Workdayz ensure quality in its corporate uniforms?",
    answer: " Workdayz adheres to strict quality checks during fabric selection, tailoring, and stitching processes. This ensures a professional finish and long-lasting wear for corporate teams."
  },
  {
    question: "6. How can I place an order for corporate uniforms?",
    answer: "  Orders can be placed through the contact form on the Workdayz website or by directly contacting the sales team. Workdayz will guide you through measurements, customization, and delivery scheduling."
  },
],
      getInTouch: { bg: Get1, img: Get2 }
    }
  },
  {
    title: "Healthcare, Clinics and Wellness",
    slug: "healthcare-clinics-wellness",
    meta: {
      title: "Durable medical scrubs for healthcare sector",
      description: "Discover premium medical scrubs for the healthcare sector. Designed for hygiene, comfort, and a professional appearance at every level of care.",
      keywords: "Medical Scrubs for Healthcare Sector"
    },
    content: {
      banner: {
        heading: "Healthcare, Clinics and Wellness",
        text: "Purpose-built apparel for care providers, combining hygiene, comfort, and trust",
        img: healthcareimg,
        bg: slide1,
        Iconbtn: Icon1,
      },
      ambience: {
        heading: "Professional Attire for Every Caregiver",
        text: "In healthcare, uniforms go beyond appearance—they build trust and ensure functionality. Our designs for doctors, nurses, clinicians, and wellness professionals are crafted for comfort, hygiene, and all-day performance, allowing your team to focus on what matters most: patient care. Whether in clinics, hospitals, or wellness centers, we create attire that supports your team while reflecting your organization’s values.",
        img: healthcareabout
      },
      industries: {
        heading: "Uniforms for Every Care Role",
        text: "From doctors to therapists—workwear tailored for care and comfort",
        title1: "DOCTORS", img1: healthcarepro1,
        title2: "LAB TECHNICIANS", img2: healthcarepro2,
        title3: "NURSES", img3: healthcarepro3,
        title4: "OT STAFF", img4: healthcarepro4,
        title5: "RECEPTION & ADMIN", img5: healthcarepro5,
        title6: "PATIENTS WEAR", img6: healthcarepro6,
      },
      process: {
        heading: "Our Process From Concept to Comfort",
        text: "A collaborative, insight-driven process to transform spaces with textiles that embody your brand’s<br> story and elevate guest experience.",
        title1: "1. RESEARCH", img1: Con1,
        title2: "2. INSPIRATION", img2: Con6,
        title3: "3. MAPPING", img3: Con2,
        title4: "4. MOOD BOARDING", img4: Con3,
        title5: "5. MOTIFS", img5: Con7,
        title6: "6. DESIGN SHEETS", img6: Con4,
        title7: "7. SAMPLING", img7: Con5,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
      getintuch: {
         heading: "Get In Touch",
         text: "Every great idea begins with a chat. Let’s talk about your next project.",
         img1: Get2,
         img2: Get1,
         img3: Icon2,
      },
     brands:{
        img: Brand1,
      },
      services: [
        { title: "Uniform packaging", text: "per staff member", img: Ser1 },
        { title: "Logo embroidery", text: "color matching", img: Ser2 },
        { title: "Accessories", text: "like belts, ties, badges", img: Ser3 }
      ],
      clients: [
        Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8,
        Logo9, Logo10, Logo11, Logo12, Logo13, Logo14, Logo15,
        Logo16, Logo17, Logo18, Logo19, Logo20, Logo21
      ],
      processsketch: {
        heading: "OUR PROCESS: FROM SKETCH TO STITCH",
        text: "From understanding your brand to delivering the finished product, we perfect every step.",
        title1: "1. BRAND REQUIREMENT", img1: Pro1,
        title2: "2. PRODUCT DESIGN", img2: Pro3,
        title3: "3. SAMPLING AND PRODUCT DEV", img3: Pro5,
        title4: "4. FORECASTING", img4: Pro7,
        title5: "7. DELIVERY", img5: Pro13,
        title6: "6. WAREHOUSING AND SHIPPING", img6: Pro11,
        title7: "5. MANUFACTURING", img7: Pro9,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
     testimonials: [
        {
          name: "Ananya Mehta",
          position: "Senior Merchandising Manager",
          img: User1,
          text: `What I value about Saraogi Clothing is that they understand fast-changing retail trends and still deliver on time.`,
        },
        {
          name: "Rajiv Nair",
          position: "Employee Welfare & Operations",
          img: User2,
          text: `Our factory staff uniforms from Saraogi have lasted far longer than expected, and the comfort feedback from workers has been very positive.`,
        },
        {
          name: "Natasha Singh",
          position: "Director – Guest Experience",
          img: User3,
          text: `The housekeeping and front desk uniforms they designed for us are both elegant and practical, our team loves wearing them.`,
        },
        {
          name: "Emma Collins",
          position: "Senior Buyer – Womenswear",
          img: User3,
          text: `We've worked with many suppliers, but Saraogi Clothing stands out for their reliability and attention to fabric detail.`,
        },
        {
          name: "Lukas Weber",
          position: "Procurement Manager",
          img: User3,
          text: `Their workwear solutions are practical and long-lasting, our technicians noticed the difference almost immediately.`,
        },
        {
          name: "Aisha Al Mansoori",
          position: "Head of Operations",
          img: User3,
          text: `Saraogi delivered exactly what we needed—uniforms that reflect luxury while staying comfortable through long shifts.`,
        },
      ],

      faq: [
  {
    question: "1. What types of uniforms does Workdayz offer for educational institutions?",
    answer: " Workdayz provides customized school and college uniforms designed for comfort, durability, and professional appearance. These uniforms are tailored to suit students, faculty, and administrative staff."
  },
  {
    question: "2. Can uniforms be customized with school colors and logo?",
    answer: " Yes, Workdayz offers full customization including school colors, logos, and specific design requirements. This helps create a cohesive and branded identity for the institution."
  },
  {
    question: "3. Are the uniforms suitable for all age groups? Are there material options suitable for daily retail use?",
    answer: " Workdayz designs uniforms that are appropriate for children, teenagers, and adult staff members. Sizes and styles are tailored to ensure a comfortable fit for every age group"
  },
  {
    question: "4. What materials are used for educational uniforms?",
    answer: " High-quality, breathable fabrics are used to ensure comfort during long school hours. The materials are chosen for durability and ease of maintenance."
  },
  {
    question: "5. How does Workdayz ensure uniform quality?",
    answer: " Each uniform undergoes strict quality checks to ensure stitching, fit, and fabric standards are met. This ensures consistent quality across all orders."
  },
  {
    question: "6. How can schools place bulk uniform orders?",
    answer: " Schools can contact Workdayz via the website’s contact form or phone to discuss requirements. The team assists with order planning, pricing, and delivery timelines."
  },
],
      getInTouch: { bg: Get1, img: Get2 }
    }
  },
  {
    title: "Educational Institutions",
    slug: "educational-institutions",
    meta: {
      title: "School Uniforms Manufacturer & Supplier | Workdayz",
      description: "Workdayz designs high-quality school uniforms for students of all grades. Durable, comfortable, and tailored for everyday use.",
      keywords: "school uniforms"
    },
    content: {
      banner: {
        heading: "Educational Institutions",
        text: "Smart, comfortable uniforms designed for students, educators, and staff",
        img: educationalimg,
        bg: slide1,
        Iconbtn: Icon1,
      },
      ambience: {
        heading: "Dressing for Learning and Leadership",
        text: "In education, uniforms foster unity, discipline, and institutional pride. Our designs for students, teachers, college faculty, and support staff are crafted for comfort, durability, and ease of wear, ensuring they meet the demands of active academic environments. From formal school attire to functional college and staff uniforms, we create collections that reflect your institution’s values while promoting confidence and belonging.",
        img: educationalabout
      },
      industries: {
        heading: "Dressing Every Role in Education",
        text: "From students to faculty—designed for learning, leading, and inspiring",
        title1: "Primary School", img1: educationalpro1,
        title2: "Middle School", img2: educationalpro2,
        title3: "Sports Uniform", img3: educationalpro3,
        title4: "Kindergarten (KG)", img4: educationalpro4,
        title5: "High School", img5: educationalpro5,
        title6: "Higher Education", img6: educationalpro6,
        title7: "Rainwear", img7: educationalpro7,
      },
      process: {
        heading: "Our Process From Concept to Comfort",
        text: "A collaborative, insight-driven process to transform spaces with textiles that embody your brand’s<br> story and elevate guest experience.",
        title1: "1. RESEARCH", img1: Con1,
        title2: "2. INSPIRATION", img2: Con6,
        title3: "3. MAPPING", img3: Con2,
        title4: "4. MOOD BOARDING", img4: Con3,
        title5: "5. MOTIFS", img5: Con7,
        title6: "6. DESIGN SHEETS", img6: Con4,
        title7: "7. SAMPLING", img7: Con5,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
      getintuch: {
         heading: "Get In Touch",
         text: "Every great idea begins with a chat. Let’s talk about your next project.",
         img1: Get2,
         img2: Get1,
         img3: Icon2,
      },
     brands:{
        img: Brand1,
      },
      services: [
        { title: "Uniform packaging", text: "per staff member", img: Ser1 },
        { title: "Logo embroidery", text: "color matching", img: Ser2 },
        { title: "Accessories", text: "like belts, ties, badges", img: Ser3 }
      ],
      clients: [
        Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8,
        Logo9, Logo10, Logo11, Logo12, Logo13, Logo14, Logo15,
        Logo16, Logo17, Logo18, Logo19, Logo20, Logo21
      ],
      processsketch: {
        heading: "OUR PROCESS: FROM SKETCH TO STITCH",
        text: "From understanding your brand to delivering the finished product, we perfect every step.",
        title1: "1. BRAND REQUIREMENT", img1: Pro1,
        title2: "2. PRODUCT DESIGN", img2: Pro3,
        title3: "3. SAMPLING AND PRODUCT DEV", img3: Pro5,
        title4: "4. FORECASTING", img4: Pro7,
        title5: "7. DELIVERY", img5: Pro13,
        title6: "6. WAREHOUSING AND SHIPPING", img6: Pro11,
        title7: "5. MANUFACTURING", img7: Pro9,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
     testimonials: [
        {
          name: "Ananya Mehta",
          position: "Senior Merchandising Manager",
          img: User1,
          text: `What I value about Saraogi Clothing is that they understand fast-changing retail trends and still deliver on time.`,
        },
        {
          name: "Rajiv Nair",
          position: "Employee Welfare & Operations",
          img: User2,
          text: `Our factory staff uniforms from Saraogi have lasted far longer than expected, and the comfort feedback from workers has been very positive.`,
        },
        {
          name: "Natasha Singh",
          position: "Director – Guest Experience",
          img: User3,
          text: `The housekeeping and front desk uniforms they designed for us are both elegant and practical, our team loves wearing them.`,
        },
        {
          name: "Emma Collins",
          position: "Senior Buyer – Womenswear",
          img: User3,
          text: `We've worked with many suppliers, but Saraogi Clothing stands out for their reliability and attention to fabric detail.`,
        },
        {
          name: "Lukas Weber",
          position: "Procurement Manager",
          img: User3,
          text: `Their workwear solutions are practical and long-lasting, our technicians noticed the difference almost immediately.`,
        },
        {
          name: "Aisha Al Mansoori",
          position: "Head of Operations",
          img: User3,
          text: `Saraogi delivered exactly what we needed—uniforms that reflect luxury while staying comfortable through long shifts.`,
        },
      ],

          faq: [
  {
    question: "1. What types of uniforms does Workdayz offer for educational institutions?",
    answer: " Workdayz provides customized school and college uniforms designed for comfort, durability, and professional appearance. These uniforms are tailored to suit students, faculty, and administrative staff."
  },
  {
    question: "2. Can uniforms be customized with school colors and logo?",
    answer: " Yes, Workdayz offers full customization including school colors, logos, and specific design requirements. This helps create a cohesive and branded identity for the institution."
  },
  {
    question: "3. Are the uniforms suitable for all age groups?",
    answer: " Workdayz designs uniforms that are appropriate for children, teenagers, and adult staff members. Sizes and styles are tailored to ensure a comfortable fit for every age group."
  },
  {
    question: "4. What materials are used for educational uniforms?",
    answer: " High-quality, breathable fabrics are used to ensure comfort during long school hours. The materials are chosen for durability and ease of maintenance."
  },
  {
    question: "5. How does Workdayz ensure uniform quality?",
    answer: "Each uniform undergoes strict quality checks to ensure stitching, fit, and fabric standards are met. This ensures consistent quality across all orders."
  },
  {
    question: "6. How can schools place bulk uniform orders?",
    answer: " Schools can contact Workdayz via the website’s contact form or phone to discuss requirements. The team assists with order planning, pricing, and delivery timelines."
  },
],
      getInTouch: { bg: Get1, img: Get2 }
    }
  },
  {
    title: "Government, Police & Defense",
    slug: "government-police-defense",
    meta: {
      title: "Durable Uniform Solutions for Government, Police and Defence",
      description: "Shop durable uniforms for government, police, and defence forces—crafted for comfort, protection, and performance to meet the demands of every duty.",
      keywords: "government uniforms"
    },
    content: {
      banner: {
        heading: "Government, Police & Defense",
        text: "Apparel that reflects honor, authority, and commitment to public service",
        img: govbg,
        bg: slide1,
        Iconbtn: Icon1,
      },
      ambience: {
        heading: "Uniforms Built for Duty and Honour",
        text: "In service to the nation, uniforms carry a deeper meaning—symbolizing discipline, integrity, and authority. Our designs for government departments, law enforcement, and defense personnel are crafted to meet rigorous standards of functionality, durability, and respect. From ceremonial attire to everyday duty wear, each piece is designed to support those who serve with pride and purpose.",
        img: govabout
      },
      industries: {
        heading: "Uniforms for Every Rank and Role",
        text: "From officers to administrative staff—uniforms tailored for service and respect",
        title1: "Infantry / Field Force", img1: govpro1,
        title2: "Officer Class", img2: govpro6,
        title3: "Parade / Ceremonial Units", img3: govpro4,
        title4: "Traffic & Patrol Police", img4: govpro5,
        title5: "Special Ops / Tactical", img5: govpro3,
        title6: "Administration / Office", img6: govpro2,
      },
      process: {
        heading: "Our Process From Concept to Comfort",
        text: "A collaborative, insight-driven process to transform spaces with textiles that embody your brand’s<br> story and elevate guest experience.",
        title1: "1. RESEARCH", img1: Con1,
        title2: "2. INSPIRATION", img2: Con6,
        title3: "3. MAPPING", img3: Con2,
        title4: "4. MOOD BOARDING", img4: Con3,
        title5: "5. MOTIFS", img5: Con7,
        title6: "6. DESIGN SHEETS", img6: Con4,
        title7: "7. SAMPLING", img7: Con5,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
      getintuch: {
         heading: "Get In Touch",
         text: "Every great idea begins with a chat. Let’s talk about your next project.",
         img1: Get2,
         img2: Get1,
         img3: Icon2,
      },
     brands:{
        img: Brand1,
      },
      services: [
        { title: "Uniform packaging", text: "per staff member", img: govser1 },
        { title: "Logo embroidery", text: "color matching", img: govser2},
      ],
      clients: [
        Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8,
        Logo9, Logo10, Logo11, Logo12, Logo13, Logo14, Logo15,
        Logo16, Logo17, Logo18, Logo19, Logo20, Logo21
      ],
      processsketch: {
        heading: "OUR PROCESS: FROM SKETCH TO STITCH",
        text: "From understanding your brand to delivering the finished product, we perfect every step.",
        title1: "1. BRAND REQUIREMENT", img1: Pro1,
        title2: "2. PRODUCT DESIGN", img2: Pro3,
        title3: "3. SAMPLING AND PRODUCT DEV", img3: Pro5,
        title4: "4. FORECASTING", img4: Pro7,
        title5: "7. DELIVERY", img5: Pro13,
        title6: "6. WAREHOUSING AND SHIPPING", img6: Pro11,
        title7: "5. MANUFACTURING", img7: Pro9,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
    testimonials: [
        {
          name: "Ananya Mehta",
          position: "Senior Merchandising Manager",
          img: User1,
          text: `What I value about Saraogi Clothing is that they understand fast-changing retail trends and still deliver on time.`,
        },
        {
          name: "Rajiv Nair",
          position: "Employee Welfare & Operations",
          img: User2,
          text: `Our factory staff uniforms from Saraogi have lasted far longer than expected, and the comfort feedback from workers has been very positive.`,
        },
        {
          name: "Natasha Singh",
          position: "Director – Guest Experience",
          img: User3,
          text: `The housekeeping and front desk uniforms they designed for us are both elegant and practical, our team loves wearing them.`,
        },
        {
          name: "Emma Collins",
          position: "Senior Buyer – Womenswear",
          img: User3,
          text: `We've worked with many suppliers, but Saraogi Clothing stands out for their reliability and attention to fabric detail.`,
        },
        {
          name: "Lukas Weber",
          position: "Procurement Manager",
          img: User3,
          text: `Their workwear solutions are practical and long-lasting, our technicians noticed the difference almost immediately.`,
        },
        {
          name: "Aisha Al Mansoori",
          position: "Head of Operations",
          img: User3,
          text: `Saraogi delivered exactly what we needed—uniforms that reflect luxury while staying comfortable through long shifts.`,
        },
      ],

   faq: [
  {
    question: "1. What uniform solutions does Workdayz offer for government and defense sectors?",
    answer: "  Workdayz provides high-quality uniforms specifically designed for government, police, and defense personnel. These uniforms combine durability, professional appearance, and functional performance for demanding duties."
  },
  {
    question: "2. Are Workdayz uniforms compliant with official standards?",
    answer: " Yes, uniforms are crafted to meet industry and sector-specific standards required by government and defense organizations. Workdayz works closely with clients to ensure specifications align with official requirements."
  },
  {
    question: "3. Can Workdayz customize uniforms for specific departments?",
    answer: " Workdayz offers tailored uniform design services to suit unique requirements of different departments. This includes options for custom colors, badges, logos, and rank insignia as needed."
  },
  {
    question: "4. What materials are used for these uniforms?",
    answer: " Durable, comfortable, and weather-appropriate fabrics are selected to withstand rigorous use and long working hours. Materials are chosen to balance strength with wearer comfort in diverse conditions."
  },
  {
    question: "5. Does Workdayz supply accessories along with uniforms?",
    answer: " Yes, accessories such as belts, caps, badges, and boots can be included as part of the uniform package. These help complete the professional look required by government and defense personnel."
  },
  {
    question: "6. How can I request a quote for government or defense uniforms?",
    answer: " You can contact Workdayz through their online form or listed contact details to request a quote. Their team will assist with specifications, pricing, and delivery timelines for your order."
  },
],
      getInTouch: { bg: Get1, img: Get2 }
    }
  },
  {
    title: "Industrial & Manufacturing",
    slug: "bed-linens",
    meta: {
      title: "Industrial & Manufacturing",
      description: "Uniforms that inspire your team, impress guests, and elevate hospitality",
      keywords: "uniforms, hospitality, hotels"
    },
    content: {
      banner: {
        heading: "Industrial & Manufacturing",
        text: "Uniforms that inspire your team, impress guests, and elevate hospitality",
        img: Banner1,
        bg: slide1,
        Iconbtn: Icon1,
      },
      ambience: {
        heading: "Tailored Uniforms for Hospitality Excellence",
        text: "In hospitality, first impressions last. Our uniforms for hotels, resorts, and restaurants are designed to balance style, comfort and practicality.",
        img: Studio
      },
      industries: {
        heading: "Uniform for Every Role",
        text: "From chefs to concierge—uniforms designed with purpose",
        title1: "CHEFS", img1: Inter1,
        title2: "MANAGEMENT", img2: Inter2,
        title3: "HOUSE KEEPING", img3: Inter3,
        title4: "GARDENING STAFF", img4: Inter4,
        title5: "F&B STAFF", img5: Inter5,
        title6: "BOAT CREWS", img6: Inter6,
        title7: "POOL SIDE", img7: Inter7,
      },
      process: {
        heading: "Our Process From Concept to Comfort",
        text: "A collaborative, insight-driven process to transform spaces with textiles that embody your brand’s<br> story and elevate guest experience.",
        title1: "1. RESEARCH", img1: Con1,
        title2: "2. INSPIRATION", img2: Con6,
        title3: "3. MAPPING", img3: Con2,
        title4: "4. MOOD BOARDING", img4: Con3,
        title5: "5. MOTIFS", img5: Con7,
        title6: "6. DESIGN SHEETS", img6: Con4,
        title7: "7. SAMPLING", img7: Con5,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
      getintuch: {
         heading: "Get In Touch",
         text: "Every great idea begins with a chat. Let’s talk about your next project.",
         img1: Get2,
         img2: Get1,
         img3: Icon2,
      },
     brands:{
        img: Brand1,
      },
      services: [
        { title: "Uniform packaging", text: "per staff member", img: Ser1 },
        { title: "Logo embroidery", text: "color matching", img: Ser2 },
        { title: "Accessories", text: "like belts, ties, badges", img: Ser3 }
      ],
      clients: [
        Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8,
        Logo9, Logo10, Logo11, Logo12, Logo13, Logo14, Logo15,
        Logo16, Logo17, Logo18, Logo19, Logo20, Logo21
      ],
      processsketch: {
        heading: "OUR PROCESS: FROM SKETCH TO STITCH",
        text: "From understanding your brand to delivering the finished product, we perfect every step.",
        title1: "1. BRAND REQUIREMENT", img1: Pro1,
        title2: "2. PRODUCT DESIGN", img2: Pro3,
        title3: "3. SAMPLING AND PRODUCT DEV", img3: Pro5,
        title4: "4. FORECASTING", img4: Pro7,
        title5: "7. DELIVERY", img5: Pro13,
        title6: "6. WAREHOUSING AND SHIPPING", img6: Pro11,
        title7: "5. MANUFACTURING", img7: Pro9,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
     testimonials: [
        {
          name: "Ananya Mehta",
          position: "Senior Merchandising Manager",
          img: User1,
          text: `What I value about Saraogi Clothing is that they understand fast-changing retail trends and still deliver on time.`,
        },
        {
          name: "Rajiv Nair",
          position: "Employee Welfare & Operations",
          img: User2,
          text: `Our factory staff uniforms from Saraogi have lasted far longer than expected, and the comfort feedback from workers has been very positive.`,
        },
        {
          name: "Natasha Singh",
          position: "Director – Guest Experience",
          img: User3,
          text: `The housekeeping and front desk uniforms they designed for us are both elegant and practical, our team loves wearing them.`,
        },
        {
          name: "Emma Collins",
          position: "Senior Buyer – Womenswear",
          img: User3,
          text: `We've worked with many suppliers, but Saraogi Clothing stands out for their reliability and attention to fabric detail.`,
        },
        {
          name: "Lukas Weber",
          position: "Procurement Manager",
          img: User3,
          text: `Their workwear solutions are practical and long-lasting, our technicians noticed the difference almost immediately.`,
        },
        {
          name: "Aisha Al Mansoori",
          position: "Head of Operations",
          img: User3,
          text: `Saraogi delivered exactly what we needed—uniforms that reflect luxury while staying comfortable through long shifts.`,
        },
      ],
      getInTouch: { bg: Get1, img: Get2 }
    }
  },
  {
    title: "Industrial & Manufacturing",
    slug: "roller-blinds",
    meta: {
      title: "Industrial & Manufacturing",
      description: "Uniforms that inspire your team, impress guests, and elevate hospitality",
      keywords: "uniforms, hospitality, hotels"
    },
    content: {
      banner: {
        heading: "Industrial & Manufacturing",
        text: "Uniforms that inspire your team, impress guests, and elevate hospitality",
        img: Banner1,
        bg: slide1,
        Iconbtn: Icon1,
      },
      ambience: {
        heading: "Tailored Uniforms for Hospitality Excellence",
        text: "In hospitality, first impressions last. Our uniforms for hotels, resorts, and restaurants are designed to balance style, comfort and practicality.",
        img: Studio
      },
      industries: {
        heading: "Uniform for Every Role",
        text: "From chefs to concierge—uniforms designed with purpose",
        title1: "CHEFS", img1: Inter1,
        title2: "MANAGEMENT", img2: Inter2,
        title3: "HOUSE KEEPING", img3: Inter3,
        title4: "GARDENING STAFF", img4: Inter4,
        title5: "F&B STAFF", img5: Inter5,
        title6: "BOAT CREWS", img6: Inter6,
        title7: "POOL SIDE", img7: Inter7,
      },
      process: {
        heading: "Our Process From Concept to Comfort",
        text: "A collaborative, insight-driven process to transform spaces with textiles that embody your brand’s<br> story and elevate guest experience.",
        title1: "1. RESEARCH", img1: Con1,
        title2: "2. INSPIRATION", img2: Con6,
        title3: "3. MAPPING", img3: Con2,
        title4: "4. MOOD BOARDING", img4: Con3,
        title5: "5. MOTIFS", img5: Con7,
        title6: "6. DESIGN SHEETS", img6: Con4,
        title7: "7. SAMPLING", img7: Con5,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
      getintuch: {
         heading: "Get In Touch",
         text: "Every great idea begins with a chat. Let’s talk about your next project.",
         img1: Get2,
         img2: Get1,
         img3: Icon2,
      },
     brands:{
        img: Brand1,
      },
      services: [
        { title: "Uniform packaging", text: "per staff member", img: Ser1 },
        { title: "Logo embroidery", text: "color matching", img: Ser2 },
        { title: "Accessories", text: "like belts, ties, badges", img: Ser3 }
      ],
      clients: [
        Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8,
        Logo9, Logo10, Logo11, Logo12, Logo13, Logo14, Logo15,
        Logo16, Logo17, Logo18, Logo19, Logo20, Logo21
      ],
      processsketch: {
        heading: "OUR PROCESS: FROM SKETCH TO STITCH",
        text: "From understanding your brand to delivering the finished product, we perfect every step.",
        title1: "1. BRAND REQUIREMENT", img1: Pro1,
        title2: "2. PRODUCT DESIGN", img2: Pro3,
        title3: "3. SAMPLING AND PRODUCT DEV", img3: Pro5,
        title4: "4. FORECASTING", img4: Pro7,
        title5: "7. DELIVERY", img5: Pro13,
        title6: "6. WAREHOUSING AND SHIPPING", img6: Pro11,
        title7: "5. MANUFACTURING", img7: Pro9,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
      testimonials: [
        {
          name: "Ananya Mehta",
          position: "Senior Merchandising Manager",
          img: User1,
          text: `What I value about Saraogi Clothing is that they understand fast-changing retail trends and still deliver on time.`,
        },
        {
          name: "Rajiv Nair",
          position: "Employee Welfare & Operations",
          img: User2,
          text: `Our factory staff uniforms from Saraogi have lasted far longer than expected, and the comfort feedback from workers has been very positive.`,
        },
        {
          name: "Natasha Singh",
          position: "Director – Guest Experience",
          img: User3,
          text: `The housekeeping and front desk uniforms they designed for us are both elegant and practical, our team loves wearing them.`,
        },
        {
          name: "Emma Collins",
          position: "Senior Buyer – Womenswear",
          img: User3,
          text: `We've worked with many suppliers, but Saraogi Clothing stands out for their reliability and attention to fabric detail.`,
        },
        {
          name: "Lukas Weber",
          position: "Procurement Manager",
          img: User3,
          text: `Their workwear solutions are practical and long-lasting, our technicians noticed the difference almost immediately.`,
        },
        {
          name: "Aisha Al Mansoori",
          position: "Head of Operations",
          img: User3,
          text: `Saraogi delivered exactly what we needed—uniforms that reflect luxury while staying comfortable through long shifts.`,
        },
      ],
      getInTouch: { bg: Get1, img: Get2 }
    }
  },
  {
    title: "Industrial & Manufacturing",
    slug: "curtains",
    meta: {
      title: "Industrial & Manufacturing",
      description: "Uniforms that inspire your team, impress guests, and elevate hospitality",
      keywords: "uniforms, hospitality, hotels"
    },
    content: {
      banner: {
        heading: "Industrial & Manufacturing",
        text: "Uniforms that inspire your team, impress guests, and elevate hospitality",
        img: Banner1,
        bg: slide1,
        Iconbtn: Icon1,
      },
      ambience: {
        heading: "Tailored Uniforms for Hospitality Excellence",
        text: "In hospitality, first impressions last. Our uniforms for hotels, resorts, and restaurants are designed to balance style, comfort and practicality.",
        img: Studio
      },
      industries: {
        heading: "Uniform for Every Role",
        text: "From chefs to concierge—uniforms designed with purpose",
        title1: "CHEFS", img1: Inter1,
        title2: "MANAGEMENT", img2: Inter2,
        title3: "HOUSE KEEPING", img3: Inter3,
        title4: "GARDENING STAFF", img4: Inter4,
        title5: "F&B STAFF", img5: Inter5,
        title6: "BOAT CREWS", img6: Inter6,
        title7: "POOL SIDE", img7: Inter7,
      },
      process: {
        heading: "Our Process From Concept to Comfort",
        text: "A collaborative, insight-driven process to transform spaces with textiles that embody your brand’s<br> story and elevate guest experience.",
        title1: "1. RESEARCH", img1: Con1,
        title2: "2. INSPIRATION", img2: Con6,
        title3: "3. MAPPING", img3: Con2,
        title4: "4. MOOD BOARDING", img4: Con3,
        title5: "5. MOTIFS", img5: Con7,
        title6: "6. DESIGN SHEETS", img6: Con4,
        title7: "7. SAMPLING", img7: Con5,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
      getintuch: {
         heading: "Get In Touch",
         text: "Every great idea begins with a chat. Let’s talk about your next project.",
         img1: Get2,
         img2: Get1,
         img3: Icon2,
      },
     brands:{
        img: Brand1,
      },
      services: [
        { title: "Uniform packaging", text: "per staff member", img: Ser1 },
        { title: "Logo embroidery", text: "color matching", img: Ser2 },
        { title: "Accessories", text: "like belts, ties, badges", img: Ser3 }
      ],
      clients: [
        Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8,
        Logo9, Logo10, Logo11, Logo12, Logo13, Logo14, Logo15,
        Logo16, Logo17, Logo18, Logo19, Logo20, Logo21
      ],
      processsketch: {
        heading: "OUR PROCESS: FROM SKETCH TO STITCH",
        text: "From understanding your brand to delivering the finished product, we perfect every step.",
        title1: "1. BRAND REQUIREMENT", img1: Pro1,
        title2: "2. PRODUCT DESIGN", img2: Pro3,
        title3: "3. SAMPLING AND PRODUCT DEV", img3: Pro5,
        title4: "4. FORECASTING", img4: Pro7,
        title5: "7. DELIVERY", img5: Pro13,
        title6: "6. WAREHOUSING AND SHIPPING", img6: Pro11,
        title7: "5. MANUFACTURING", img7: Pro9,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
     testimonials: [
        {
          name: "Ananya Mehta",
          position: "Senior Merchandising Manager",
          img: User1,
          text: `What I value about Saraogi Clothing is that they understand fast-changing retail trends and still deliver on time.`,
        },
        {
          name: "Rajiv Nair",
          position: "Employee Welfare & Operations",
          img: User2,
          text: `Our factory staff uniforms from Saraogi have lasted far longer than expected, and the comfort feedback from workers has been very positive.`,
        },
        {
          name: "Natasha Singh",
          position: "Director – Guest Experience",
          img: User3,
          text: `The housekeeping and front desk uniforms they designed for us are both elegant and practical, our team loves wearing them.`,
        },
        {
          name: "Emma Collins",
          position: "Senior Buyer – Womenswear",
          img: User3,
          text: `We've worked with many suppliers, but Saraogi Clothing stands out for their reliability and attention to fabric detail.`,
        },
        {
          name: "Lukas Weber",
          position: "Procurement Manager",
          img: User3,
          text: `Their workwear solutions are practical and long-lasting, our technicians noticed the difference almost immediately.`,
        },
        {
          name: "Aisha Al Mansoori",
          position: "Head of Operations",
          img: User3,
          text: `Saraogi delivered exactly what we needed—uniforms that reflect luxury while staying comfortable through long shifts.`,
        },
      ],
      getInTouch: { bg: Get1, img: Get2 }
    }
  },
  {
    title: "Industrial & Manufacturing",
    slug: "bathroom-furnishing",
    meta: {
      title: "Industrial & Manufacturing",
      description: "Uniforms that inspire your team, impress guests, and elevate hospitality",
      keywords: "uniforms, hospitality, hotels"
    },
    content: {
      banner: {
        heading: "Industrial & Manufacturing",
        text: "Uniforms that inspire your team, impress guests, and elevate hospitality",
        img: Banner1,
        bg: slide1,
        Iconbtn: Icon1,
      },
      ambience: {
        heading: "Tailored Uniforms for Hospitality Excellence",
        text: "In hospitality, first impressions last. Our uniforms for hotels, resorts, and restaurants are designed to balance style, comfort and practicality.",
        img: Studio
      },
      industries: {
        heading: "Uniform for Every Role",
        text: "From chefs to concierge—uniforms designed with purpose",
        title1: "CHEFS", img1: Inter1,
        title2: "MANAGEMENT", img2: Inter2,
        title3: "HOUSE KEEPING", img3: Inter3,
        title4: "GARDENING STAFF", img4: Inter4,
        title5: "F&B STAFF", img5: Inter5,
        title6: "BOAT CREWS", img6: Inter6,
        title7: "POOL SIDE", img7: Inter7,
      },
      process: {
        heading: "Our Process From Concept to Comfort",
        text: "A collaborative, insight-driven process to transform spaces with textiles that embody your brand’s<br> story and elevate guest experience.",
        title1: "1. RESEARCH", img1: Con1,
        title2: "2. INSPIRATION", img2: Con6,
        title3: "3. MAPPING", img3: Con2,
        title4: "4. MOOD BOARDING", img4: Con3,
        title5: "5. MOTIFS", img5: Con7,
        title6: "6. DESIGN SHEETS", img6: Con4,
        title7: "7. SAMPLING", img7: Con5,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
      getintuch: {
         heading: "Get In Touch",
         text: "Every great idea begins with a chat. Let’s talk about your next project.",
         img1: Get2,
         img2: Get1,
         img3: Icon2,
      },
     brands:{
        img: Brand1,
      },
      services: [
        { title: "Uniform packaging", text: "per staff member", img: Ser1 },
        { title: "Logo embroidery", text: "color matching", img: Ser2 },
        { title: "Accessories", text: "like belts, ties, badges", img: Ser3 }
      ],
      clients: [
        Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8,
        Logo9, Logo10, Logo11, Logo12, Logo13, Logo14, Logo15,
        Logo16, Logo17, Logo18, Logo19, Logo20, Logo21
      ],
      processsketch: {
        heading: "OUR PROCESS: FROM SKETCH TO STITCH",
        text: "From understanding your brand to delivering the finished product, we perfect every step.",
        title1: "1. BRAND REQUIREMENT", img1: Pro1,
        title2: "2. PRODUCT DESIGN", img2: Pro3,
        title3: "3. SAMPLING AND PRODUCT DEV", img3: Pro5,
        title4: "4. FORECASTING", img4: Pro7,
        title5: "7. DELIVERY", img5: Pro13,
        title6: "6. WAREHOUSING AND SHIPPING", img6: Pro11,
        title7: "5. MANUFACTURING", img7: Pro9,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
     testimonials: [
        {
          name: "Ananya Mehta",
          position: "Senior Merchandising Manager",
          img: User1,
          text: `What I value about Saraogi Clothing is that they understand fast-changing retail trends and still deliver on time.`,
        },
        {
          name: "Rajiv Nair",
          position: "Employee Welfare & Operations",
          img: User2,
          text: `Our factory staff uniforms from Saraogi have lasted far longer than expected, and the comfort feedback from workers has been very positive.`,
        },
        {
          name: "Natasha Singh",
          position: "Director – Guest Experience",
          img: User3,
          text: `The housekeeping and front desk uniforms they designed for us are both elegant and practical, our team loves wearing them.`,
        },
        {
          name: "Emma Collins",
          position: "Senior Buyer – Womenswear",
          img: User3,
          text: `We've worked with many suppliers, but Saraogi Clothing stands out for their reliability and attention to fabric detail.`,
        },
        {
          name: "Lukas Weber",
          position: "Procurement Manager",
          img: User3,
          text: `Their workwear solutions are practical and long-lasting, our technicians noticed the difference almost immediately.`,
        },
        {
          name: "Aisha Al Mansoori",
          position: "Head of Operations",
          img: User3,
          text: `Saraogi delivered exactly what we needed—uniforms that reflect luxury while staying comfortable through long shifts.`,
        },
      ],
      getInTouch: { bg: Get1, img: Get2 }
    }
  },
  {
    title: "Industrial & Manufacturing",
    slug: "uniform-packaging",
    meta: {
      title: "Industrial & Manufacturing",
      description: "Uniforms that inspire your team, impress guests, and elevate hospitality",
      keywords: "uniforms, hospitality, hotels"
    },
    content: {
      banner: {
        heading: "Industrial & Manufacturing",
        text: "Uniforms that inspire your team, impress guests, and elevate hospitality",
        img: Banner1,
        bg: slide1,
        Iconbtn: Icon1,
      },
      ambience: {
        heading: "Tailored Uniforms for Hospitality Excellence",
        text: "In hospitality, first impressions last. Our uniforms for hotels, resorts, and restaurants are designed to balance style, comfort and practicality.",
        img: Studio
      },
      industries: {
        heading: "Uniform for Every Role",
        text: "From chefs to concierge—uniforms designed with purpose",
        title1: "CHEFS", img1: Inter1,
        title2: "MANAGEMENT", img2: Inter2,
        title3: "HOUSE KEEPING", img3: Inter3,
        title4: "GARDENING STAFF", img4: Inter4,
        title5: "F&B STAFF", img5: Inter5,
        title6: "BOAT CREWS", img6: Inter6,
        title7: "POOL SIDE", img7: Inter7,
      },
      process: {
        heading: "Our Process From Concept to Comfort",
        text: "A collaborative, insight-driven process to transform spaces with textiles that embody your brand’s<br> story and elevate guest experience.",
        title1: "1. RESEARCH", img1: Con1,
        title2: "2. INSPIRATION", img2: Con6,
        title3: "3. MAPPING", img3: Con2,
        title4: "4. MOOD BOARDING", img4: Con3,
        title5: "5. MOTIFS", img5: Con7,
        title6: "6. DESIGN SHEETS", img6: Con4,
        title7: "7. SAMPLING", img7: Con5,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
      getintuch: {
         heading: "Get In Touch",
         text: "Every great idea begins with a chat. Let’s talk about your next project.",
         img1: Get2,
         img2: Get1,
         img3: Icon2,
      },
     brands:{
        img: Brand1,
      },
      services: [
        { title: "Uniform packaging", text: "per staff member", img: Ser1 },
        { title: "Logo embroidery", text: "color matching", img: Ser2 },
        { title: "Accessories", text: "like belts, ties, badges", img: Ser3 }
      ],
      clients: [
        Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8,
        Logo9, Logo10, Logo11, Logo12, Logo13, Logo14, Logo15,
        Logo16, Logo17, Logo18, Logo19, Logo20, Logo21
      ],
      processsketch: {
        heading: "OUR PROCESS: FROM SKETCH TO STITCH",
        text: "From understanding your brand to delivering the finished product, we perfect every step.",
        title1: "1. BRAND REQUIREMENT", img1: Pro1,
        title2: "2. PRODUCT DESIGN", img2: Pro3,
        title3: "3. SAMPLING AND PRODUCT DEV", img3: Pro5,
        title4: "4. FORECASTING", img4: Pro7,
        title5: "7. DELIVERY", img5: Pro13,
        title6: "6. WAREHOUSING AND SHIPPING", img6: Pro11,
        title7: "5. MANUFACTURING", img7: Pro9,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
     testimonials: [
        {
          name: "Ananya Mehta",
          position: "Senior Merchandising Manager",
          img: User1,
          text: `What I value about Saraogi Clothing is that they understand fast-changing retail trends and still deliver on time.`,
        },
        {
          name: "Rajiv Nair",
          position: "Employee Welfare & Operations",
          img: User2,
          text: `Our factory staff uniforms from Saraogi have lasted far longer than expected, and the comfort feedback from workers has been very positive.`,
        },
        {
          name: "Natasha Singh",
          position: "Director – Guest Experience",
          img: User3,
          text: `The housekeeping and front desk uniforms they designed for us are both elegant and practical, our team loves wearing them.`,
        },
        {
          name: "Emma Collins",
          position: "Senior Buyer – Womenswear",
          img: User3,
          text: `We've worked with many suppliers, but Saraogi Clothing stands out for their reliability and attention to fabric detail.`,
        },
        {
          name: "Lukas Weber",
          position: "Procurement Manager",
          img: User3,
          text: `Their workwear solutions are practical and long-lasting, our technicians noticed the difference almost immediately.`,
        },
        {
          name: "Aisha Al Mansoori",
          position: "Head of Operations",
          img: User3,
          text: `Saraogi delivered exactly what we needed—uniforms that reflect luxury while staying comfortable through long shifts.`,
        },
      ],
      getInTouch: { bg: Get1, img: Get2 }
    }
  },
  {
    title: "Industrial & Manufacturing",
    slug: "logo-embroidery",
    meta: {
      title: "Industrial & Manufacturing",
      description: "Uniforms that inspire your team, impress guests, and elevate hospitality",
      keywords: "uniforms, hospitality, hotels"
    },
    content: {
      banner: {
        heading: "Industrial & Manufacturing",
        text: "Uniforms that inspire your team, impress guests, and elevate hospitality",
        img: Banner1,
        bg: slide1,
        Iconbtn: Icon1,
      },
      ambience: {
        heading: "Tailored Uniforms for Hospitality Excellence",
        text: "In hospitality, first impressions last. Our uniforms for hotels, resorts, and restaurants are designed to balance style, comfort and practicality.",
        img: Studio
      },
      industries: {
        heading: "Uniform for Every Role",
        text: "From chefs to concierge—uniforms designed with purpose",
        title1: "CHEFS", img1: Inter1,
        title2: "MANAGEMENT", img2: Inter2,
        title3: "HOUSE KEEPING", img3: Inter3,
        title4: "GARDENING STAFF", img4: Inter4,
        title5: "F&B STAFF", img5: Inter5,
        title6: "BOAT CREWS", img6: Inter6,
        title7: "POOL SIDE", img7: Inter7,
      },
      process: {
        heading: "Our Process From Concept to Comfort",
        text: "A collaborative, insight-driven process to transform spaces with textiles that embody your brand’s<br> story and elevate guest experience.",
        title1: "1. RESEARCH", img1: Con1,
        title2: "2. INSPIRATION", img2: Con6,
        title3: "3. MAPPING", img3: Con2,
        title4: "4. MOOD BOARDING", img4: Con3,
        title5: "5. MOTIFS", img5: Con7,
        title6: "6. DESIGN SHEETS", img6: Con4,
        title7: "7. SAMPLING", img7: Con5,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
      getintuch: {
         heading: "Get In Touch",
         text: "Every great idea begins with a chat. Let’s talk about your next project.",
         img1: Get2,
         img2: Get1,
         img3: Icon2,
      },
     brands:{
        img: Brand1,
      },
      services: [
        { title: "Uniform packaging", text: "per staff member", img: Ser1 },
        { title: "Logo embroidery", text: "color matching", img: Ser2 },
        { title: "Accessories", text: "like belts, ties, badges", img: Ser3 }
      ],
      clients: [
        Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8,
        Logo9, Logo10, Logo11, Logo12, Logo13, Logo14, Logo15,
        Logo16, Logo17, Logo18, Logo19, Logo20, Logo21
      ],
      processsketch: {
        heading: "OUR PROCESS: FROM SKETCH TO STITCH",
        text: "From understanding your brand to delivering the finished product, we perfect every step.",
        title1: "1. BRAND REQUIREMENT", img1: Pro1,
        title2: "2. PRODUCT DESIGN", img2: Pro3,
        title3: "3. SAMPLING AND PRODUCT DEV", img3: Pro5,
        title4: "4. FORECASTING", img4: Pro7,
        title5: "7. DELIVERY", img5: Pro13,
        title6: "6. WAREHOUSING AND SHIPPING", img6: Pro11,
        title7: "5. MANUFACTURING", img7: Pro9,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
     testimonials: [
        {
          name: "Ananya Mehta",
          position: "Senior Merchandising Manager",
          img: User1,
          text: `What I value about Saraogi Clothing is that they understand fast-changing retail trends and still deliver on time.`,
        },
        {
          name: "Rajiv Nair",
          position: "Employee Welfare & Operations",
          img: User2,
          text: `Our factory staff uniforms from Saraogi have lasted far longer than expected, and the comfort feedback from workers has been very positive.`,
        },
        {
          name: "Natasha Singh",
          position: "Director – Guest Experience",
          img: User3,
          text: `The housekeeping and front desk uniforms they designed for us are both elegant and practical, our team loves wearing them.`,
        },
        {
          name: "Emma Collins",
          position: "Senior Buyer – Womenswear",
          img: User3,
          text: `We've worked with many suppliers, but Saraogi Clothing stands out for their reliability and attention to fabric detail.`,
        },
        {
          name: "Lukas Weber",
          position: "Procurement Manager",
          img: User3,
          text: `Their workwear solutions are practical and long-lasting, our technicians noticed the difference almost immediately.`,
        },
        {
          name: "Aisha Al Mansoori",
          position: "Head of Operations",
          img: User3,
          text: `Saraogi delivered exactly what we needed—uniforms that reflect luxury while staying comfortable through long shifts.`,
        },
      ],
      getInTouch: { bg: Get1, img: Get2 }
    }
  },
  {
    title: "Industrial & Manufacturing",
    slug: "accessories",
    meta: {
      title: "Industrial & Manufacturing",
      description: "Uniforms that inspire your team, impress guests, and elevate hospitality",
      keywords: "uniforms, hospitality, hotels"
    },
    content: {
      banner: {
        heading: "Industrial & Manufacturing",
        text: "Uniforms that inspire your team, impress guests, and elevate hospitality",
        img: Banner1,
        bg: slide1,
        Iconbtn: Icon1,
      },
      ambience: {
        heading: "Tailored Uniforms for Hospitality Excellence",
        text: "In hospitality, first impressions last. Our uniforms for hotels, resorts, and restaurants are designed to balance style, comfort and practicality.",
        img: Studio
      },
      industries: {
        heading: "Uniform for Every Role",
        text: "From chefs to concierge—uniforms designed with purpose",
        title1: "CHEFS", img1: Inter1,
        title2: "MANAGEMENT", img2: Inter2,
        title3: "HOUSE KEEPING", img3: Inter3,
        title4: "GARDENING STAFF", img4: Inter4,
        title5: "F&B STAFF", img5: Inter5,
        title6: "BOAT CREWS", img6: Inter6,
        title7: "POOL SIDE", img7: Inter7,
      },
      process: {
        heading: "Our Process From Concept to Comfort",
        text: "A collaborative, insight-driven process to transform spaces with textiles that embody your brand’s<br> story and elevate guest experience.",
        title1: "1. RESEARCH", img1: Con1,
        title2: "2. INSPIRATION", img2: Con6,
        title3: "3. MAPPING", img3: Con2,
        title4: "4. MOOD BOARDING", img4: Con3,
        title5: "5. MOTIFS", img5: Con7,
        title6: "6. DESIGN SHEETS", img6: Con4,
        title7: "7. SAMPLING", img7: Con5,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
      getintuch: {
         heading: "Get In Touch",
         text: "Every great idea begins with a chat. Let’s talk about your next project.",
         img1: Get2,
         img2: Get1,
         img3: Icon2,
      },
     brands:{
        img: Brand1,
      },
      services: [
        { title: "Uniform packaging", text: "per staff member", img: Ser1 },
        { title: "Logo embroidery", text: "color matching", img: Ser2 },
        { title: "Accessories", text: "like belts, ties, badges", img: Ser3 }
      ],
      clients: [
        Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8,
        Logo9, Logo10, Logo11, Logo12, Logo13, Logo14, Logo15,
        Logo16, Logo17, Logo18, Logo19, Logo20, Logo21
      ],
      processsketch: {
        heading: "OUR PROCESS: FROM SKETCH TO STITCH",
        text: "From understanding your brand to delivering the finished product, we perfect every step.",
        title1: "1. BRAND REQUIREMENT", img1: Pro1,
        title2: "2. PRODUCT DESIGN", img2: Pro3,
        title3: "3. SAMPLING AND PRODUCT DEV", img3: Pro5,
        title4: "4. FORECASTING", img4: Pro7,
        title5: "7. DELIVERY", img5: Pro13,
        title6: "6. WAREHOUSING AND SHIPPING", img6: Pro11,
        title7: "5. MANUFACTURING", img7: Pro9,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
     testimonials: [
        {
          name: "Ananya Mehta",
          position: "Senior Merchandising Manager",
          img: User1,
          text: `What I value about Saraogi Clothing is that they understand fast-changing retail trends and still deliver on time.`,
        },
        {
          name: "Rajiv Nair",
          position: "Employee Welfare & Operations",
          img: User2,
          text: `Our factory staff uniforms from Saraogi have lasted far longer than expected, and the comfort feedback from workers has been very positive.`,
        },
        {
          name: "Natasha Singh",
          position: "Director – Guest Experience",
          img: User3,
          text: `The housekeeping and front desk uniforms they designed for us are both elegant and practical, our team loves wearing them.`,
        },
        {
          name: "Emma Collins",
          position: "Senior Buyer – Womenswear",
          img: User3,
          text: `We've worked with many suppliers, but Saraogi Clothing stands out for their reliability and attention to fabric detail.`,
        },
        {
          name: "Lukas Weber",
          position: "Procurement Manager",
          img: User3,
          text: `Their workwear solutions are practical and long-lasting, our technicians noticed the difference almost immediately.`,
        },
        {
          name: "Aisha Al Mansoori",
          position: "Head of Operations",
          img: User3,
          text: `Saraogi delivered exactly what we needed—uniforms that reflect luxury while staying comfortable through long shifts.`,
        },
      ],
      getInTouch: { bg: Get1, img: Get2 }
    }
  },
  {
    title: "Industrial & Manufacturing",
    slug: "sachets",
    meta: {
      title: "Industrial & Manufacturing",
      description: "Uniforms that inspire your team, impress guests, and elevate hospitality",
      keywords: "uniforms, hospitality, hotels"
    },
    content: {
      banner: {
        heading: "Industrial & Manufacturing",
        text: "Uniforms that inspire your team, impress guests, and elevate hospitality",
        img: Banner1,
        bg: slide1,
        Iconbtn: Icon1,
      },
      ambience: {
        heading: "Tailored Uniforms for Hospitality Excellence",
        text: "In hospitality, first impressions last. Our uniforms for hotels, resorts, and restaurants are designed to balance style, comfort and practicality.",
        img: Studio
      },
      industries: {
        heading: "Uniform for Every Role",
        text: "From chefs to concierge—uniforms designed with purpose",
        title1: "CHEFS", img1: Inter1,
        title2: "MANAGEMENT", img2: Inter2,
        title3: "HOUSE KEEPING", img3: Inter3,
        title4: "GARDENING STAFF", img4: Inter4,
        title5: "F&B STAFF", img5: Inter5,
        title6: "BOAT CREWS", img6: Inter6,
        title7: "POOL SIDE", img7: Inter7,
      },
      process: {
        heading: "Our Process From Concept to Comfort",
        text: "A collaborative, insight-driven process to transform spaces with textiles that embody your brand’s<br> story and elevate guest experience.",
        title1: "1. RESEARCH", img1: Con1,
        title2: "2. INSPIRATION", img2: Con6,
        title3: "3. MAPPING", img3: Con2,
        title4: "4. MOOD BOARDING", img4: Con3,
        title5: "5. MOTIFS", img5: Con7,
        title6: "6. DESIGN SHEETS", img6: Con4,
        title7: "7. SAMPLING", img7: Con5,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
      getintuch: {
         heading: "Get In Touch",
         text: "Every great idea begins with a chat. Let’s talk about your next project.",
         img1: Get2,
         img2: Get1,
         img3: Icon2,
      },
     brands:{
        img: Brand1,
      },
      services: [
        { title: "Uniform packaging", text: "per staff member", img: Ser1 },
        { title: "Logo embroidery", text: "color matching", img: Ser2 },
        { title: "Accessories", text: "like belts, ties, badges", img: Ser3 }
      ],
      clients: [
        Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8,
        Logo9, Logo10, Logo11, Logo12, Logo13, Logo14, Logo15,
        Logo16, Logo17, Logo18, Logo19, Logo20, Logo21
      ],
      processsketch: {
        heading: "OUR PROCESS: FROM SKETCH TO STITCH",
        text: "From understanding your brand to delivering the finished product, we perfect every step.",
        title1: "1. BRAND REQUIREMENT", img1: Pro1,
        title2: "2. PRODUCT DESIGN", img2: Pro3,
        title3: "3. SAMPLING AND PRODUCT DEV", img3: Pro5,
        title4: "4. FORECASTING", img4: Pro7,
        title5: "7. DELIVERY", img5: Pro13,
        title6: "6. WAREHOUSING AND SHIPPING", img6: Pro11,
        title7: "5. MANUFACTURING", img7: Pro9,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
    testimonials: [
        {
          name: "Ananya Mehta",
          position: "Senior Merchandising Manager",
          img: User1,
          text: `What I value about Saraogi Clothing is that they understand fast-changing retail trends and still deliver on time.`,
        },
        {
          name: "Rajiv Nair",
          position: "Employee Welfare & Operations",
          img: User2,
          text: `Our factory staff uniforms from Saraogi have lasted far longer than expected, and the comfort feedback from workers has been very positive.`,
        },
        {
          name: "Natasha Singh",
          position: "Director – Guest Experience",
          img: User3,
          text: `The housekeeping and front desk uniforms they designed for us are both elegant and practical, our team loves wearing them.`,
        },
        {
          name: "Emma Collins",
          position: "Senior Buyer – Womenswear",
          img: User3,
          text: `We've worked with many suppliers, but Saraogi Clothing stands out for their reliability and attention to fabric detail.`,
        },
        {
          name: "Lukas Weber",
          position: "Procurement Manager",
          img: User3,
          text: `Their workwear solutions are practical and long-lasting, our technicians noticed the difference almost immediately.`,
        },
        {
          name: "Aisha Al Mansoori",
          position: "Head of Operations",
          img: User3,
          text: `Saraogi delivered exactly what we needed—uniforms that reflect luxury while staying comfortable through long shifts.`,
        },
      ],
      getInTouch: { bg: Get1, img: Get2 }
    }
  },
  {
    title: "Hospitality & Resorts",
    slug: "hospitality-resorts",
    meta: {
      title: "Stylish Uniform Solutions for Hotels, Resorts & Hospitality ",
      description: "Transform your hospitality brand with tailored uniforms that reflect professionalism, comfort, and timeless style across hotels and resorts.",
      keywords: "hospitality workwear solutions"
    },
    content: {
      banner: {
        heading: "Hospitality & Resorts",
        text: "Uniforms that inspire your team, impress guests, and elevate hospitality",
        img: Banner1,
        bg: slide1,
        Iconbtn: Icon1,
      },
      ambience: {
        heading: "Tailored Uniforms for Hospitality Excellence",
        text: "In hospitality, first impressions last. Our uniforms for hotels, resorts, and restaurants are designed to balance style, comfort, and practicality, ensuring your team feels confident and looks the part. From front desk to housekeeping, every piece is crafted to enhance guest experience while representing your property’s unique identity. We collaborate closely with you to create attire that aligns with your brand vision and elevates every guest interaction.",
        img: Studio
      },
      industries: {
        heading: "Uniform for Every Role",
        text: "From chefs to concierge—uniforms designed with purpose",
        title1: "CHEFS", img1: Inter1,
        title2: "MANAGEMENT", img2: Inter2,
        title3: "HOUSE KEEPING", img3: Inter3,
        title4: "GARDENING STAFF", img4: Inter4,
        title5: "F&B STAFF", img5: Inter5,
        title6: "BOAT CREWS", img6: Inter6,
        title7: "POOL SIDE", img7: Inter7,
      },
      process: {
        heading: "Our Process From Concept to Comfort",
        text: "A collaborative, insight-driven process to transform spaces with textiles that embody your brand’s<br> story and elevate guest experience.",
        title1: "1. RESEARCH", img1: Con1,
        title2: "2. INSPIRATION", img2: Con6,
        title3: "3. MAPPING", img3: Con2,
        title4: "4. MOOD BOARDING", img4: Con3,
        title5: "5. MOTIFS", img5: Con7,
        title6: "6. DESIGN SHEETS", img6: Con4,
        title7: "7. SAMPLING", img7: Con5,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },



      getintuch: {
         heading: "Get In Touch",
         text: "Every great idea begins with a chat. Let’s talk about your next project.",
         img1: Get2,
         img2: Get1,
         img3: Icon2,
      },
     brands:{
        img: Brand1,
      },
      services: [
        { title: "Uniform packaging", text: "per staff member", img: Ser1 },
        { title: "Logo embroidery", text: "color matching", img: Ser2 },
        { title: "Accessories", text: "like belts, ties, badges", img: Ser3 }
      ],
      clients: [
        Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8,
        Logo9, Logo10, Logo11, Logo12, Logo13, Logo14, Logo15,
        Logo16, Logo17, Logo18, Logo19, Logo20, Logo21
      ],
      processsketch: {
        heading: "OUR PROCESS: FROM SKETCH TO STITCH",
        text: "From understanding your brand to delivering the finished product, we perfect every step.",
        title1: "1. BRAND REQUIREMENT", img1: Pro1,
        title2: "2. PRODUCT DESIGN", img2: Pro3,
        title3: "3. SAMPLING AND PRODUCT DEV", img3: Pro5,
        title4: "4. FORECASTING", img4: Pro7,
        title5: "7. DELIVERY", img5: Pro13,
        title6: "6. WAREHOUSING AND SHIPPING", img6: Pro11,
        title7: "5. MANUFACTURING", img7: Pro9,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
    testimonials: [
        {
          name: "Ananya Mehta",
          position: "Senior Merchandising Manager",
          img: User1,
          text: `What I value about Saraogi Clothing is that they understand fast-changing retail trends and still deliver on time.`,
        },
        {
          name: "Rajiv Nair",
          position: "Employee Welfare & Operations",
          img: User2,
          text: `Our factory staff uniforms from Saraogi have lasted far longer than expected, and the comfort feedback from workers has been very positive.`,
        },
        {
          name: "Natasha Singh",
          position: "Director – Guest Experience",
          img: User3,
          text: `The housekeeping and front desk uniforms they designed for us are both elegant and practical, our team loves wearing them.`,
        },
        {
          name: "Emma Collins",
          position: "Senior Buyer – Womenswear",
          img: User3,
          text: `We've worked with many suppliers, but Saraogi Clothing stands out for their reliability and attention to fabric detail.`,
        },
        {
          name: "Lukas Weber",
          position: "Procurement Manager",
          img: User3,
          text: `Their workwear solutions are practical and long-lasting, our technicians noticed the difference almost immediately.`,
        },
        {
          name: "Aisha Al Mansoori",
          position: "Head of Operations",
          img: User3,
          text: `Saraogi delivered exactly what we needed—uniforms that reflect luxury while staying comfortable through long shifts.`,
        },
      ],
faq: [
  {
    question: "1. What hospitality uniforms does Workdayz offer?",
    answer: " Workdayz provides stylish and functional uniforms specifically designed for hotel, resort, and restaurant staff. These uniforms combine professional appearance with comfort for long working hours."
  },
  {
    question: "2. Can Workdayz customize uniforms for my hospitality business?",
    answer: " Yes, Workdayz offers bespoke uniform designs tailored to your brand colors, logo, and dress code requirements. Custom solutions help create a cohesive and professional team appearance."
  },
  {
    question: "3. Are Workdayz hospitality uniforms durabl?",
    answer: " Hospitality uniforms are crafted with quality fabrics chosen for durability and ease of maintenance. This ensures long-lasting wear even in demanding service environments"
  },
  {
    question: "4. Do Workdayz uniforms support different roles in hospitality?",
    answer: " Yes, uniforms are available for various roles including front desk, housekeeping, servers, and management. Each design considers the specific functional needs of the role."
  },
  {
    question: "5.How does Workdayz ensure comfort in hospitality uniforms?",
    answer: " Uniforms are made with breathable, lightweight materials to support comfort during extended shifts. Ergonomic design features help staff move freely and confidently."
  },
  {
    question: "6. w can I order hospitality uniforms from Workdayz?",
    answer: " You can request a quote or place an order via the contact form on the website or by calling their team. Workdayz customer support assists you in selecting sizes and design options."
  }
],

      getInTouch: { bg: Get1, img: Get2 }
    }
  },
  // Aap dusre product ka object yahan add kar sakte ho
];
